export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-300">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold font-heading text-background-50">黑料爆料</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              黑料爆料网 — 全网八卦吃瓜第一站。一站聚合最新最全的热搜八卦、娱乐圈内幕与独家爆料，安全进入爆料平台首页实时查看最新内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-800 flex items-center justify-center text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-live-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">快速导航</h3>
            <ul className="space-y-2.5">
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">热搜榜单</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">实时快讯</a></li>
              <li><a href="#carousel" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">焦点专题</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">深度爆料</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">热门话题</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">关于我们</h3>
            <ul className="space-y-2.5">
              <li><a href="#about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">平台介绍</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">常见问题</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">爆料投稿</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4 font-heading">合作伙伴</h3>
            <p className="text-sm text-background-500 leading-relaxed">
              更多优质合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 黑料爆料网 版权所有 | 本站内容仅供娱乐参考，不构成任何建议
          </p>
          <p className="text-xs text-background-500">
            安全进入黑料爆料网官网首页，在线浏览最新爆料内容
          </p>
        </div>
      </div>
    </footer>
  );
}